// extracted by mini-css-extract-plugin
export var quillEditor = "_mu-1";
export var variable = "_mu-0";